import React from 'react'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import ReactDOM from 'react-dom/client'
import { PersistGate } from 'redux-persist/integration/react'

import { persistor, store } from './store'

import App from './App'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'antd/dist/reset.css'
import './assets/css/helpers.css'
import './assets/css/main.css'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.Fragment>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <HashRouter>
            <App />
          </HashRouter>
        </PersistGate>
      </Provider>
  </React.Fragment>
)